// extracted by mini-css-extract-plugin
module.exports = {"mobileMenu":"mobile-menu_mobileMenu___HjrB","opened":"mobile-menu_opened__l6I5L"};